import { default as data } from "../../../assets/slide/data.json"

export function getData() {
    const itemList = data.map((item, index) => {
        return { ...item, index };
    })
    return itemList;

}